import { useEffect, useState } from "react";
import { cx } from "../../components";
import styles from "./Vitrine.module.css";

/** Les écrans de la vitrine, dans l'ordre, pour les repères et les ancres. */
export const ECRANS = [
  { id: "accueil", libelle: "Accueil" },
  { id: "etapes", libelle: "Comment ça marche" },
  { id: "espaces", libelle: "Les espaces" },
  { id: "grand-livre", libelle: "Le grand livre" },
  { id: "inscription", libelle: "Inscription" },
] as const;

/**
 * Les repères de progression : un point par écran, le courant plein. L'écran
 * courant est celui qui occupe au moins la moitié de la fenêtre — un
 * observateur d'intersection, pas une animation.
 */
export function VitrineReperes() {
  const [courant, setCourant] = useState<string>(ECRANS[0].id);

  useEffect(() => {
    const observateur = new IntersectionObserver(
      (entrees) => {
        for (const e of entrees) {
          if (e.isIntersecting) {
            setCourant(e.target.id);
          }
        }
      },
      { threshold: 0.5 },
    );
    for (const { id } of ECRANS) {
      const el = document.getElementById(id);
      if (el) {
        observateur.observe(el);
      }
    }
    return () => observateur.disconnect();
  }, []);

  return (
    <nav aria-label="Progression dans la page">
      <ol className={styles.reperes}>
        {ECRANS.map((e) => (
          <li key={e.id}>
            <a
              href={`#${e.id}`}
              className={cx(styles.repere, courant === e.id && styles.repereActif)}
              aria-current={courant === e.id ? "true" : undefined}
              aria-label={e.libelle}
              title={e.libelle}
            />
          </li>
        ))}
      </ol>
    </nav>
  );
}
